import { PFE_AND, PfeAndCondition } from './and.model';
import { PfeConditionsService } from '../conditions.service';
import { ConditionEvaluator } from '../condition-evaluator.model';

export function pfeAndConditionEvaluator(pfeConditionsService: PfeConditionsService) {
  return {
    type: PFE_AND,
    evaluator: (pfeAndCondition: PfeAndCondition, state?: unknown) =>
      pfeAndCondition.conditions.every((conditions) => pfeConditionsService.evaluateCondition(conditions, state)),
  } as ConditionEvaluator;
}
